export const NavBarLinks = [{
    "id": 1,
    "parent_id": 1,
    "title": "Головна",
    "url": "/Home",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "HomeIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 2,
    "parent_id": 1,
    "title": "Форма",
    "url": "/FormPage",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "FeedIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 3,
    "parent_id": 1,
    "title": "Список працівників",
    "url": "/WorkersList",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "RecentActorsIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 4,
    "parent_id": 1,
    "title": "Список пацієнтів",
    "url": "/PatientList",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "ContactEmergencyIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 5,
    "parent_id": 1,
    "title": "Сторінка сканування",
    "url": "/ScanPage",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "QrCodeScannerIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 6,
    "parent_id": 1,
    "title": "Створити скерування",
    "url": "/FindPatientForm",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "EditNoteIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 7,
    "parent_id": 1,
    "title": "Створити клініку",
    "url": "/CreateClinic",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "DomainAddIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 8,
    "parent_id": 1,
    "title": "Список клінік",
    "url": "/ClinicList",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "CorporateFareIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 9,
    "parent_id": 1,
    "title": "Список скерувань",
    "url": "/Referrals",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "BallotIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 10,
    "parent_id": 1,
    "title": "Створити працівника",
    "url": "/CreateNewUser",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "AddBoxIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 11,
    "parent_id": 1,
    "title": "Історія дій співробітника",
    "url": "/LogsPage",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "InfoIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 12,
    "parent_id": 1,
    "title": "Перелік договорів",
    "url": "/Contracts",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "ReceiptLongIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}, {
    "id": 13,
    "parent_id": 1,
    "title": "Статистика",
    "url": "/Statistics",
    "cover": {
        "id": 1,
        "mime_type": "image/svg+xml",
        "original": "",
        "alt": null,
        "conversions": {
            "icon": "LeaderboardIcon",
            "large": "",
            "thumb": "",
            "original": "",
            "large-mobile": "",
            "thumb-mobile": ""
        }
    },
    "children": []
}]